import React from "react";

import { AppShape, HurdleShape } from "@eave/shared/types/api";
import HurdleView from "underwriter_dashboard/shared/HurdleView";

import SandboxScenarioCalculator from "./SandboxScenarioCalculator";
import SandboxScenarioProvider from "./SandboxScenarioProvider";

require("underwriter_dashboard/hurdle_editors/styles.module.scss");

interface Props {
  app: AppShape;
  hurdle: HurdleShape;
  onHide: Function;
}

const SandboxScenario = (props: Props): React.ReactNode => {
  const { app, hurdle, onHide } = props;

  return (
    <HurdleView app={app} hurdle={hurdle} onHide={onHide} hideTitle>
      <SandboxScenarioProvider appId={app.id} ownedRealEstate={app.owned_real_estate}>
        <SandboxScenarioCalculator />
      </SandboxScenarioProvider>
    </HurdleView>
  );
};

export default SandboxScenario;
